import React from "react";

export const WaterBackupImg = () => {
  return (
    <svg
      width="84px"
      height="84px"
      viewBox="0 0 84 84"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>654B4D8F-0DC0-44D1-826B-BDE34624B33C</title>
      <defs>
        <rect id="path-1" x="0" y="0" width="84" height="84"></rect>
      </defs>
      <g
        id="↳-home-wizard"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Home---Create-a-custom-quote-side-bar"
          transform="translate(-564.000000, -1247.000000)"
        >
          <g id="Group-2-Copy-6" transform="translate(564.000000, 1247.000000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1"></use>
            </mask>
            <use id="Rectangle" fill="#FFFFFF" xlinkHref="#path-1"></use>
            <g id="Group-3-Copy-2" mask="url(#mask-2)">
              <g transform="translate(-62.400000, 14.400000)">
                <g id="Group-14" strokeWidth="1" fill="none">
                  <polygon
                    id="Path"
                    fill="#8D98C2"
                    fillRule="nonzero"
                    points="13.8180274 28.2580208 10.9873366 23.5345913 37.4084854 0.860759494 105.349169 0.860759494 105.349169 7.47356082 80.8151471 33.9268213 52.5061869 39.5949367"
                  ></polygon>
                  <polygon
                    id="Path"
                    fill="#DADFF6"
                    fillRule="nonzero"
                    points="117.000935 0 108.139032 0 108.139032 4.62883799 105.349578 1.46539051 82.7871728 23.9823335 79.0263176 27.7349305 74.3261006 46.4992764 82.7871728 67.1392405 126.031214 67.1392405 126.031214 24.9204827 117.000935 14.6790766"
                  ></polygon>
                  <rect
                    id="Rectangle"
                    fill="#E7EBFD"
                    fillRule="nonzero"
                    x="10.9873366"
                    y="23.8860759"
                    width="71.7408449"
                    height="43.2531646"
                  ></rect>
                  <rect
                    id="Rectangle"
                    fill="#8D98C2"
                    fillRule="nonzero"
                    x="57.3065007"
                    y="37.443038"
                    width="15.2960961"
                    height="13.556962"
                  ></rect>
                  <polygon
                    id="Path"
                    fill="#8D98C2"
                    fillRule="nonzero"
                    points="103.194789 42.1772152 103.194789 37.443038 97.5934016 37.443038 97.5934016 42.1772152 102.727725 42.1772152"
                  ></polygon>
                  <polygon
                    id="Path"
                    fill="#8D98C2"
                    fillRule="nonzero"
                    points="102.727725 46.2658228 97.5934016 46.2658228 97.5934016 51 103.194789 51 103.194789 46.2658228"
                  ></polygon>
                  <rect
                    id="Rectangle"
                    fill="#8D98C2"
                    fillRule="nonzero"
                    x="107.28811"
                    y="37.443038"
                    width="5.60138729"
                    height="4.73417722"
                  ></rect>
                  <rect
                    id="Rectangle"
                    fill="#8D98C2"
                    fillRule="nonzero"
                    x="107.28811"
                    y="46.2658228"
                    width="5.60138729"
                    height="4.73417722"
                  ></rect>
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                    x="140.034682"
                    y="14.2025316"
                    width="1"
                    height="39.5949367"
                    rx="0.5"
                  ></rect>
                </g>
                <rect
                  id="Rectangle"
                  fill="#000000"
                  x="49.6190024"
                  y="67.8176944"
                  width="103.980998"
                  height="1"
                ></rect>
              </g>
            </g>
            <path
              d="M18.9145419,61.3652938 C23.0775218,58.678728 28.8111983,59.7225752 32.867176,62.5691383 C34.1907464,63.5107979 35.4064511,64.5955279 36.4922529,65.8036652 C37.1254539,66.4981802 37.7257189,67.2272761 38.2998768,67.9814793 C38.4413332,68.1665177 38.5821107,68.353411 38.7201717,68.5421511 C38.8146397,68.6697478 38.908322,68.7982338 39.0012184,68.9276093 C40.1656617,70.5461777 41.2332147,72.2489357 42.2782906,73.9362238 C44.8871894,78.1482502 47.5640908,82.4856628 51.5391799,85.4428872 C52.3581689,86.0519907 53.5007723,86.6005129 54.3398361,86.0188786 C55.0679569,85.513768 55.099148,84.4516716 54.9334338,83.5812753 C54.3173847,80.3564632 52.0951189,77.684086 49.7342906,75.4028209 C47.3734925,73.1215705 44.7599563,71.0300723 42.9761404,68.2735178 C41.1922942,65.5169576 40.3772976,61.8368748 41.9397672,58.9498321 C43.2863395,56.46193 46.1835032,55.0663976 49.0114233,55.001401 C51.8390976,54.9370203 54.5864467,56.0361965 56.9788364,57.5455129 C59.3710108,59.0554475 61.4744982,60.9713236 63.6698064,62.7552405 C64.993153,63.8314907 66.8408649,64.8994005 68.2830392,63.9881734 C69.5011878,63.2181009 69.5962053,61.3694622 68.8702153,60.12476 C68.1442253,58.8800577 66.8484702,58.0978186 65.6062679,57.3683255 C61.7495318,55.1026224 57.8927236,52.8371264 54.0358431,50.5718377 C52.8525716,49.8774383 51.6435072,49.1608422 50.7700623,48.1019941 C49.8963694,47.0437621 49.4114413,45.5564471 49.8929616,44.2713909 C50.3680357,43.005007 51.6949213,42.2008675 53.0373497,42.0330493 C54.3788951,41.8656183 55.7319641,42.2376016 56.9869434,42.7414678 C61.6897886,44.630153 72.7633881,56.98622 75.7147005,59.0987367 C77.6113567,60.4555254 79.6037576,62.1732057 79.7955699,64.4971608 C80.0345247,67.3903187 77.1558021,69.7912676 74.2663043,70.0719261 C71.3772048,70.3534138 68.5770065,69.0971588 65.9955489,67.7690221 C63.4140914,66.4408854 60.7795624,64.9765144 57.8820015,64.7921536 C54.9844955,64.6078187 51.7336157,66.1566665 51.0467756,68.9774054 C50.4494471,71.4318397 51.9679532,73.9645503 53.9459523,75.5350113 C55.4942245,76.7646162 57.3112748,77.5834593 59.0664366,78.5042228 C59.5538388,78.7591254 60.0361176,79.0227095 60.5065048,79.3044788 C61.7107634,80.0272859 62.8364552,80.8735688 63.8653575,81.8296279 C64.9454767,82.8317014 65.9150271,83.9467099 66.757381,85.1555311 C67.4295686,86.1187259 68.0160586,87.1389717 68.5101214,88.2045618 C68.5854051,88.3673284 68.6585061,88.5323615 68.7294243,88.6996613 C68.7965955,88.8596126 68.8616865,89.0216342 68.9233921,89.1852704 C69.7290027,91.307438 70.0428328,93.6855899 69.0136622,95.6666669 C67.9871026,97.6423793 65.7635858,98.8122747 63.5433094,98.9745117 C62.2590661,99.0511294 60.9720316,98.8811011 59.7517428,98.4736133 C58.8542934,98.182111 57.9855388,97.8087316 57.1564435,97.3581874 C53.3124237,95.2948911 50.2691482,92.0231521 47.4898348,88.6596777 C44.7111891,85.2964366 42.0946648,81.7552137 38.795911,78.9002519 C35.4973412,76.0446606 31.3637302,73.8857376 27.0007188,73.9185299 C22.6379229,73.9506995 18.140366,76.6089904 16.9012538,80.7920216 C15.0951279,77.679849 13.8738027,74.1320385 14.0350534,70.5377027 C14.1963041,66.943367 15.8914007,63.3166551 18.9145419,61.3652938 Z"
              id="Path"
              fill={"#0033FF"}
              fillRule="nonzero"
              mask="url(#mask-2)"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
